import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { incPrediction, decPrediction } from '../../actions';

class Controls extends Component {

  state = {
    pressed: false
  };

  handleStateChange = (incrementing, e) => {
    const typesToPress = ["mousedown", "keydown"];
    const typesToRelease = ["mouseup", "mouseout", "keyup"];
    const method = incrementing ? this.inc : this.dec;
    if (typesToPress.includes(e.type) && (e.type !== "keydown" || (e.key === "Enter" || e.key === " "))) {
      this.setState({ pressed: true }, () => {
        requestAnimationFrame(method);
      });
    } else if (typesToRelease.includes(e.type)) {
      this.setState({ pressed: false });
    }
  }

  inc = () => {
    if(this.state.pressed) {
      this.props.incPrediction({ id: this.props.id, index: this.props.index });
      requestAnimationFrame(this.inc);
    }
  }

  dec = () => {
    if(this.state.pressed) {
      this.props.decPrediction({ id: this.props.id, index: this.props.index });
      requestAnimationFrame(this.dec);
    }
  }

  render() {
    return (
      <div className="controls">
        <div className="volume-control">
          <button
            style={{ cursor: "pointer" }}
            aria-label={this.props.t("Decrease volume button")}
            onMouseDown={(e) => this.handleStateChange(false, e)}
            onMouseUp={(e) => this.handleStateChange(false, e)}
            onMouseOut={(e) => this.handleStateChange(false, e)}
            onKeyDown={(e) => this.handleStateChange(false, e)}
            onKeyUp={(e) => this.handleStateChange(false, e)}
          > - </button>
          
          <button
            style={{ cursor: "pointer" }}
            aria-label={this.props.t("Increase volume button")}
            onMouseDown={(e) => this.handleStateChange(true, e)}
            onMouseUp={(e) => this.handleStateChange(true, e)}
            onMouseOut={(e) => this.handleStateChange(true, e)}
            onKeyDown={(e) => this.handleStateChange(true, e)}
            onKeyUp={(e) => this.handleStateChange(true, e)}
          > + </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  id: ownProps.id,
  type: state.blotPaper.blotPapers[ownProps.id-1].type,
  prediction: state.blotPaper.blotPapers[ownProps.id-1].prediction
});

export default connect(mapStateToProps, { incPrediction, decPrediction })(withTranslation()(Controls));
